module.exports = __webpack_public_path__ + "static/media/partes.c1c9b27c.png";